let bsParams = {


}


let paramsRule = {


    id:'',     // id
	publishMaterialId:'',     // publishMaterialId
	publishId:'',     // 出版单位ID

}

export { bsParams,paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsSEt5.js